import { request } from '../@utils'
import { requestFile } from '../@utils'

// 订单发货
const orderSend = {
    // 商品列表
    detail: params => {
        return request.post('order-delivery/getOrderDetail', { data: params })
    },
    // 发货
    deliver: params => {
        return request.post('order-delivery/orderDeliver', { data: params })
    },
    // 修改 物流单号
    updateOrderDeliver: params => {
        return request.post('order-delivery/updateOrderDeliver', { data: params })
    },
    // 物流信息
    orderDeliveryInfo: params => {
        return request.post('order-delivery/pageOrderDelivery', { data: params })
    },
    // 根据单个物流编号查 物流信息
    orderDeliveryInfoByWaybillNo: params => {
        return request.post('order-delivery/getByWaybillNo', { data: params })
    },
    // 快递100,物流信息
    getOrderDeliveryInfo: params => {
        return requestFile.post('kd100/order/getByWaybillNo', { data: params })
    },
}
export default orderSend